import { setupListeners } from '@reduxjs/toolkit/query';
import { store } from './store';

// Init RTK Query
setupListeners(store.dispatch);

export { store } from './store';
